import { render, staticRenderFns } from "./bigScreenMap.vue?vue&type=template&id=c0f13214&"
import script from "./bigScreenMap.vue?vue&type=script&lang=js&"
export * from "./bigScreenMap.vue?vue&type=script&lang=js&"
import style0 from "./bigScreenMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bigScreenMap.vue"
export default component.exports